export const state = {
  role_id: localStorage.getItem('role_id'),
  is_penunjukan: localStorage.getItem('is_penunjukan'),
  jenis_petugas: localStorage.getItem('jenis_petugas'),
  api_url: process.env.API_URL,
  api_token: localStorage.getItem('api_token'),
  jwt: localStorage.getItem('jwt'),
  session_id: localStorage.getItem("session_id"),
  session_user: '',
  biodata_user: '',
  max_doc_size: 2097152,
  max_foto_size: 512000,
  interval_search: 5000
}



// WEBPACK FOOTER //
// ./src/store/state.js